import { ForgotPasswordIcon, LayersIcon } from "@hugeicons/core-free-icons";
import { HugeiconsIcon } from "@hugeicons/react";
import { Form } from "@inertiajs/react";
import { Button } from "@/components/ui/button";
import {
	Field,
	FieldDescription,
	FieldGroup,
	FieldLabel,
} from "@/components/ui/field";
import { GridPattern } from "@/components/ui/grid-pattern";
import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";

export default function New() {
	return (
		<div className="grid min-h-svh lg:grid-cols-2">
			<div className="flex flex-col gap-4 p-6 md:p-10">
				<div className="flex justify-center gap-2 md:justify-start">
					<a href="/" className="flex items-center gap-2 font-medium">
						<div className="flex size-6 items-center justify-center rounded-md bg-primary text-primary-foreground">
							<HugeiconsIcon
								icon={LayersIcon}
								strokeWidth={2}
								className="size-4"
							/>
						</div>
						AML Management
					</a>
				</div>
				<div className="flex flex-1 items-center justify-center">
					<div className="w-full max-w-sm">
						<Form
							action="/identity/password_reset"
							method="post"
							disableWhileProcessing
							className="flex flex-col gap-6"
						>
							<FieldGroup>
								<div className="flex flex-col items-center gap-1 text-center">
									<div className="mb-2 flex size-12 items-center justify-center rounded-lg bg-primary/10">
										<HugeiconsIcon
											icon={ForgotPasswordIcon}
											strokeWidth={2}
											className="size-6 text-primary"
										/>
									</div>
									<h1 className="font-bold text-2xl">Obnovení hesla</h1>
									<p className="text-balance text-muted-foreground text-sm">
										Zadejte svůj e-mail a my vám pošleme odkaz pro obnovení
										hesla
									</p>
								</div>

								<Field>
									<FieldLabel htmlFor="email">Email</FieldLabel>
									<Input
										id="email"
										name="email"
										type="email"
										placeholder="jan.novak@example.com"
										required
										autoComplete="email"
									/>
								</Field>

								<Field>
									<Button type="submit" className="w-full">
										Odeslat odkaz pro obnovení
									</Button>
								</Field>

								<Field>
									<FieldDescription className="text-center">
										<a href="/sign_in" className="underline underline-offset-4">
											Zpět na přihlášení
										</a>
									</FieldDescription>
								</Field>
							</FieldGroup>
						</Form>
					</div>
				</div>
			</div>
			<div className="relative hidden overflow-hidden bg-muted lg:block">
				<GridPattern
					squares={[
						[0, 1],
						[1, 3],
						[2, 2],
						[3, 4],
						[4, 0],
						[5, 2],
						[6, 4],
						[7, 1],
						[8, 3],
						[9, 5],
					]}
					className={cn(
						"mask-[radial-gradient(500px_circle_at_center,white,transparent)]",
						"inset-x-0 inset-y-[-30%] h-[160%] skew-y-12",
					)}
				/>
			</div>
		</div>
	);
}
